import "./PDFErrorPop.css";
import ReplayIcon from "@mui/icons-material/Replay";

const PDFErrorPop = ({ errorMessage }) => {
  const reloadPage = () => window.location.reload();

  const isCriticalError = [
    "The document is invalid or corrupted",
    "The document is missing",
    "Unexpected server response",
    "Cannot load the document",
  ].includes(errorMessage);

  return (
    <div className="PDFErrorPop__container">
      <div className="PDFErrorPop__message">{errorMessage}</div>
      {isCriticalError && (
        <div className="PDFErrorPop__reloadButton">
          <ReplayIcon onClick={reloadPage} />
        </div>
      )}
    </div>
  );
};

export default PDFErrorPop;
